import classNames from 'classnames';
import { ReactNode } from 'react';

export interface SubduedTextSetProps {
  set: ReactNode[];
  classNameItem?: string;
}

export const SubduedTextSet = ({ set, classNameItem }: SubduedTextSetProps) => {
  return (
    <span
      className={classNames(
        'flex text-[12px] leading-[20px] text-gray-500 divide-gray-200 w-full',
        'md:gap-2 divide-x-0 md:divide-x flex-col md:flex-row',
      )}
    >
      {set.map((value, index) => (
        <span
          key={index}
          className={classNames(
            'text-left line-clamp-3',
            {
              'w-[80%]': set.length === 1 && !classNameItem?.includes('w-'),
              'text-nowrap': set.length !== 1 && !classNameItem?.includes('text-'),
              'break-all': set.length === 1 && !classNameItem?.includes('break-'),
              'md:pl-2': index !== 0,
            },
            classNameItem,
          )}
        >
          {value}
        </span>
      ))}
    </span>
  );
};
